import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { GlobeIcon } from '@mote/assets/icons'
import { LOCALIZATION_LANGUAGES } from '@mote/helpers/constants'
import { isEnglishSpeakingLocale } from '@mote/helpers/l10n'
import { useLocale } from '@mote/l10n/providers/LocaleProvider'
import { Dropdown } from '@mote/ui'
import { InfoModal } from './InfoModal'

export const LanguagePicker = () => {
  const [showInfoModal, setShowInfoModal] = useState(false)
  const { locale, updateLocale } = useLocale()

  const selectLanguage = async locale => {
    await updateLocale(locale)
    if (!isEnglishSpeakingLocale(locale)) {
      setShowInfoModal(true)
    }
  }

  const closeInfoModal = () => {
    setShowInfoModal(false)
  }

  return (
    <Root>
      <StyledDropdown
        width={150}
        height={200}
        onAction={selectLanguage}
        triggerElementContent={
          <DropdownTriggerText>
            <GlobeIcon color='currentColor' />
            {locale.name}
          </DropdownTriggerText>
        }
        placement='top-left'
      >
        {LOCALIZATION_LANGUAGES.map(language => (
          <Dropdown.Item key={language.code}>
            <Dropdown.ItemText>{language.name}</Dropdown.ItemText>
          </Dropdown.Item>
        ))}
      </StyledDropdown>

      <InfoModal onClose={closeInfoModal} isVisible={showInfoModal} />
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  margin-bottom: 8px;
`

const StyledDropdown = styled(Dropdown)`
  .dropdown-trigger-container {
    color: #ffffff;
    border: none;

    &:hover {
      color: rgba(255, 255, 255, 0.6);
      background: transparent;
    }

    &:active {
      color: rgba(255, 255, 255, 0.3);
    }

    &:focus {
      color: #ffffff;
      background: transparent;
    }
  }
`

const DropdownTriggerText = styled.span`
  display: flex;
  align-items: center;
  color: inherit;

  svg {
    margin-right: 8px;
  }
`

LanguagePicker.propTypes = {
  activeLanguage: PropTypes.string,
  onTranslate: PropTypes.func
}
